module.exports = __webpack_public_path__ + "img/VideocamOutlined.ff4e68e5.svg";